import { render, staticRenderFns } from "./IncidentShareButtons.vue?vue&type=template&id=c5211ef0&scoped=true&"
import script from "./IncidentShareButtons.vue?vue&type=script&lang=js&"
export * from "./IncidentShareButtons.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/incident.css?vue&type=style&index=0&id=c5211ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5211ef0",
  null
  
)

export default component.exports